function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["__scopeContextMenu", "disabled"],
  _excluded2 = ["__scopeContextMenu"],
  _excluded3 = ["__scopeContextMenu"],
  _excluded4 = ["__scopeContextMenu"],
  _excluded5 = ["__scopeContextMenu"],
  _excluded6 = ["__scopeContextMenu"],
  _excluded7 = ["__scopeContextMenu"],
  _excluded8 = ["__scopeContextMenu"],
  _excluded9 = ["__scopeContextMenu"],
  _excluded10 = ["__scopeContextMenu"],
  _excluded11 = ["__scopeContextMenu"],
  _excluded12 = ["__scopeContextMenu"],
  _excluded13 = ["__scopeContextMenu"],
  _excluded14 = ["__scopeContextMenu"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var $l8XVT$babelruntimehelpersextends = require("@babel/runtime/helpers/extends");
var $l8XVT$react = require("react");
var $l8XVT$radixuiprimitive = require("@radix-ui/primitive");
var $l8XVT$radixuireactcontext = require("@radix-ui/react-context");
var $l8XVT$radixuireactprimitive = require("@radix-ui/react-primitive");
var $l8XVT$radixuireactmenu = require("@radix-ui/react-menu");
var $l8XVT$radixuireactusecallbackref = require("@radix-ui/react-use-callback-ref");
var $l8XVT$radixuireactusecontrollablestate = require("@radix-ui/react-use-controllable-state");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
$parcel$export(module.exports, "createContextMenuScope", function () {
  return $5de197f6cd80e8e9$export$1059331f43ddcc82;
});
$parcel$export(module.exports, "ContextMenu", function () {
  return $5de197f6cd80e8e9$export$8dc6765e8be191c7;
});
$parcel$export(module.exports, "ContextMenuTrigger", function () {
  return $5de197f6cd80e8e9$export$be6fc7b1d5b0beb9;
});
$parcel$export(module.exports, "ContextMenuPortal", function () {
  return $5de197f6cd80e8e9$export$14afd0be83e45060;
});
$parcel$export(module.exports, "ContextMenuContent", function () {
  return $5de197f6cd80e8e9$export$572205900c9369e;
});
$parcel$export(module.exports, "ContextMenuGroup", function () {
  return $5de197f6cd80e8e9$export$9860523b0fcdd664;
});
$parcel$export(module.exports, "ContextMenuLabel", function () {
  return $5de197f6cd80e8e9$export$d4b9d3b609a10742;
});
$parcel$export(module.exports, "ContextMenuItem", function () {
  return $5de197f6cd80e8e9$export$16a26dc176a49100;
});
$parcel$export(module.exports, "ContextMenuCheckboxItem", function () {
  return $5de197f6cd80e8e9$export$b6adbe51d5d8b7ec;
});
$parcel$export(module.exports, "ContextMenuRadioGroup", function () {
  return $5de197f6cd80e8e9$export$db5c89af5ed9aa07;
});
$parcel$export(module.exports, "ContextMenuRadioItem", function () {
  return $5de197f6cd80e8e9$export$8a727d09a7d9bfc2;
});
$parcel$export(module.exports, "ContextMenuItemIndicator", function () {
  return $5de197f6cd80e8e9$export$9ed8194dee42d94b;
});
$parcel$export(module.exports, "ContextMenuSeparator", function () {
  return $5de197f6cd80e8e9$export$8d6b009fadfe1207;
});
$parcel$export(module.exports, "ContextMenuArrow", function () {
  return $5de197f6cd80e8e9$export$f47d0a58228a61e2;
});
$parcel$export(module.exports, "ContextMenuSub", function () {
  return $5de197f6cd80e8e9$export$5bc21d1c00c4b201;
});
$parcel$export(module.exports, "ContextMenuSubTrigger", function () {
  return $5de197f6cd80e8e9$export$30b2b5c64556d316;
});
$parcel$export(module.exports, "ContextMenuSubContent", function () {
  return $5de197f6cd80e8e9$export$2c967063bd2dc512;
});
$parcel$export(module.exports, "Root", function () {
  return $5de197f6cd80e8e9$export$be92b6f5f03c0fe9;
});
$parcel$export(module.exports, "Trigger", function () {
  return $5de197f6cd80e8e9$export$41fb9f06171c75f4;
});
$parcel$export(module.exports, "Portal", function () {
  return $5de197f6cd80e8e9$export$602eac185826482c;
});
$parcel$export(module.exports, "Content", function () {
  return $5de197f6cd80e8e9$export$7c6e2c02157bb7d2;
});
$parcel$export(module.exports, "Group", function () {
  return $5de197f6cd80e8e9$export$eb2fcfdbd7ba97d4;
});
$parcel$export(module.exports, "Label", function () {
  return $5de197f6cd80e8e9$export$b04be29aa201d4f5;
});
$parcel$export(module.exports, "Item", function () {
  return $5de197f6cd80e8e9$export$6d08773d2e66f8f2;
});
$parcel$export(module.exports, "CheckboxItem", function () {
  return $5de197f6cd80e8e9$export$16ce288f89fa631c;
});
$parcel$export(module.exports, "RadioGroup", function () {
  return $5de197f6cd80e8e9$export$a98f0dcb43a68a25;
});
$parcel$export(module.exports, "RadioItem", function () {
  return $5de197f6cd80e8e9$export$371ab307eab489c0;
});
$parcel$export(module.exports, "ItemIndicator", function () {
  return $5de197f6cd80e8e9$export$c3468e2714d175fa;
});
$parcel$export(module.exports, "Separator", function () {
  return $5de197f6cd80e8e9$export$1ff3c3f08ae963c0;
});
$parcel$export(module.exports, "Arrow", function () {
  return $5de197f6cd80e8e9$export$21b07c8f274aebd5;
});
$parcel$export(module.exports, "Sub", function () {
  return $5de197f6cd80e8e9$export$d7a01e11500dfb6f;
});
$parcel$export(module.exports, "SubTrigger", function () {
  return $5de197f6cd80e8e9$export$2ea8a7a591ac5eac;
});
$parcel$export(module.exports, "SubContent", function () {
  return $5de197f6cd80e8e9$export$6d4de93b380beddf;
});

/* -------------------------------------------------------------------------------------------------
 * ContextMenu
 * -----------------------------------------------------------------------------------------------*/
var $5de197f6cd80e8e9$var$CONTEXT_MENU_NAME = 'ContextMenu';
var _$l8XVT$radixuireactc = $l8XVT$radixuireactcontext.createContextScope($5de197f6cd80e8e9$var$CONTEXT_MENU_NAME, [$l8XVT$radixuireactmenu.createMenuScope]),
  _$l8XVT$radixuireactc2 = _slicedToArray(_$l8XVT$radixuireactc, 2),
  $5de197f6cd80e8e9$var$createContextMenuContext = _$l8XVT$radixuireactc2[0],
  $5de197f6cd80e8e9$export$1059331f43ddcc82 = _$l8XVT$radixuireactc2[1];
var $5de197f6cd80e8e9$var$useMenuScope = $l8XVT$radixuireactmenu.createMenuScope();
var _$5de197f6cd80e8e9$va = $5de197f6cd80e8e9$var$createContextMenuContext($5de197f6cd80e8e9$var$CONTEXT_MENU_NAME),
  _$5de197f6cd80e8e9$va2 = _slicedToArray(_$5de197f6cd80e8e9$va, 2),
  $5de197f6cd80e8e9$var$ContextMenuProvider = _$5de197f6cd80e8e9$va2[0],
  $5de197f6cd80e8e9$var$useContextMenuContext = _$5de197f6cd80e8e9$va2[1];
var $5de197f6cd80e8e9$export$8dc6765e8be191c7 = function $5de197f6cd80e8e9$export$8dc6765e8be191c7(props) {
  var __scopeContextMenu = props.__scopeContextMenu,
    children = props.children,
    onOpenChange = props.onOpenChange,
    dir = props.dir,
    _props$modal = props.modal,
    modal = _props$modal === void 0 ? true : _props$modal;
  var _$l8XVT$react$useStat = $l8XVT$react.useState(false),
    _$l8XVT$react$useStat2 = _slicedToArray(_$l8XVT$react$useStat, 2),
    open1 = _$l8XVT$react$useStat2[0],
    setOpen = _$l8XVT$react$useStat2[1];
  var menuScope = $5de197f6cd80e8e9$var$useMenuScope(__scopeContextMenu);
  var handleOpenChangeProp = $l8XVT$radixuireactusecallbackref.useCallbackRef(onOpenChange);
  var handleOpenChange = $l8XVT$react.useCallback(function (open) {
    setOpen(open);
    handleOpenChangeProp(open);
  }, [handleOpenChangeProp]);
  return /*#__PURE__*/$l8XVT$react.createElement($5de197f6cd80e8e9$var$ContextMenuProvider, {
    scope: __scopeContextMenu,
    open: open1,
    onOpenChange: handleOpenChange,
    modal: modal
  }, /*#__PURE__*/$l8XVT$react.createElement($l8XVT$radixuireactmenu.Root, $parcel$interopDefault($l8XVT$babelruntimehelpersextends)({}, menuScope, {
    dir: dir,
    open: open1,
    onOpenChange: handleOpenChange,
    modal: modal
  }), children));
};
/*#__PURE__*/
Object.assign($5de197f6cd80e8e9$export$8dc6765e8be191c7, {
  displayName: $5de197f6cd80e8e9$var$CONTEXT_MENU_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ContextMenuTrigger
 * -----------------------------------------------------------------------------------------------*/
var $5de197f6cd80e8e9$var$TRIGGER_NAME = 'ContextMenuTrigger';
var $5de197f6cd80e8e9$export$be6fc7b1d5b0beb9 = /*#__PURE__*/$l8XVT$react.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    triggerProps = _objectWithoutProperties(props, _excluded);
  var context = $5de197f6cd80e8e9$var$useContextMenuContext($5de197f6cd80e8e9$var$TRIGGER_NAME, __scopeContextMenu);
  var menuScope = $5de197f6cd80e8e9$var$useMenuScope(__scopeContextMenu);
  var pointRef = $l8XVT$react.useRef({
    x: 0,
    y: 0
  });
  var virtualRef = $l8XVT$react.useRef({
    getBoundingClientRect: function getBoundingClientRect() {
      return DOMRect.fromRect(_objectSpread({
        width: 0,
        height: 0
      }, pointRef.current));
    }
  });
  var longPressTimerRef = $l8XVT$react.useRef(0);
  var clearLongPress = $l8XVT$react.useCallback(function () {
    return window.clearTimeout(longPressTimerRef.current);
  }, []);
  var handleOpen = function handleOpen(event) {
    pointRef.current = {
      x: event.clientX,
      y: event.clientY
    };
    context.onOpenChange(true);
  };
  $l8XVT$react.useEffect(function () {
    return clearLongPress;
  }, [clearLongPress]);
  $l8XVT$react.useEffect(function () {
    return void (disabled && clearLongPress());
  }, [disabled, clearLongPress]);
  return /*#__PURE__*/$l8XVT$react.createElement($l8XVT$react.Fragment, null, /*#__PURE__*/$l8XVT$react.createElement($l8XVT$radixuireactmenu.Anchor, $parcel$interopDefault($l8XVT$babelruntimehelpersextends)({}, menuScope, {
    virtualRef: virtualRef
  })), /*#__PURE__*/$l8XVT$react.createElement($l8XVT$radixuireactprimitive.Primitive.span, $parcel$interopDefault($l8XVT$babelruntimehelpersextends)({
    "data-state": context.open ? 'open' : 'closed',
    "data-disabled": disabled ? '' : undefined
  }, triggerProps, {
    ref: forwardedRef // prevent iOS context menu from appearing
    ,

    style: _objectSpread({
      WebkitTouchCallout: 'none'
    }, props.style) // if trigger is disabled, enable the native Context Menu
    ,

    onContextMenu: disabled ? props.onContextMenu : $l8XVT$radixuiprimitive.composeEventHandlers(props.onContextMenu, function (event) {
      // clearing the long press here because some platforms already support
      // long press to trigger a `contextmenu` event
      clearLongPress();
      handleOpen(event);
      event.preventDefault();
    }),
    onPointerDown: disabled ? props.onPointerDown : $l8XVT$radixuiprimitive.composeEventHandlers(props.onPointerDown, $5de197f6cd80e8e9$var$whenTouchOrPen(function (event) {
      // clear the long press here in case there's multiple touch points
      clearLongPress();
      longPressTimerRef.current = window.setTimeout(function () {
        return handleOpen(event);
      }, 700);
    })),
    onPointerMove: disabled ? props.onPointerMove : $l8XVT$radixuiprimitive.composeEventHandlers(props.onPointerMove, $5de197f6cd80e8e9$var$whenTouchOrPen(clearLongPress)),
    onPointerCancel: disabled ? props.onPointerCancel : $l8XVT$radixuiprimitive.composeEventHandlers(props.onPointerCancel, $5de197f6cd80e8e9$var$whenTouchOrPen(clearLongPress)),
    onPointerUp: disabled ? props.onPointerUp : $l8XVT$radixuiprimitive.composeEventHandlers(props.onPointerUp, $5de197f6cd80e8e9$var$whenTouchOrPen(clearLongPress))
  })));
});
/*#__PURE__*/
Object.assign($5de197f6cd80e8e9$export$be6fc7b1d5b0beb9, {
  displayName: $5de197f6cd80e8e9$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ContextMenuPortal
 * -----------------------------------------------------------------------------------------------*/
var $5de197f6cd80e8e9$var$PORTAL_NAME = 'ContextMenuPortal';
var $5de197f6cd80e8e9$export$14afd0be83e45060 = function $5de197f6cd80e8e9$export$14afd0be83e45060(props) {
  var __scopeContextMenu = props.__scopeContextMenu,
    portalProps = _objectWithoutProperties(props, _excluded2);
  var menuScope = $5de197f6cd80e8e9$var$useMenuScope(__scopeContextMenu);
  return /*#__PURE__*/$l8XVT$react.createElement($l8XVT$radixuireactmenu.Portal, $parcel$interopDefault($l8XVT$babelruntimehelpersextends)({}, menuScope, portalProps));
};
/*#__PURE__*/
Object.assign($5de197f6cd80e8e9$export$14afd0be83e45060, {
  displayName: $5de197f6cd80e8e9$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ContextMenuContent
 * -----------------------------------------------------------------------------------------------*/
var $5de197f6cd80e8e9$var$CONTENT_NAME = 'ContextMenuContent';
var $5de197f6cd80e8e9$export$572205900c9369e = /*#__PURE__*/$l8XVT$react.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    contentProps = _objectWithoutProperties(props, _excluded3);
  var context = $5de197f6cd80e8e9$var$useContextMenuContext($5de197f6cd80e8e9$var$CONTENT_NAME, __scopeContextMenu);
  var menuScope = $5de197f6cd80e8e9$var$useMenuScope(__scopeContextMenu);
  var hasInteractedOutsideRef = $l8XVT$react.useRef(false);
  return /*#__PURE__*/$l8XVT$react.createElement($l8XVT$radixuireactmenu.Content, $parcel$interopDefault($l8XVT$babelruntimehelpersextends)({}, menuScope, contentProps, {
    ref: forwardedRef,
    side: "right",
    sideOffset: 2,
    align: "start",
    onCloseAutoFocus: function onCloseAutoFocus(event) {
      var _props$onCloseAutoFoc;
      (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
      if (!event.defaultPrevented && hasInteractedOutsideRef.current) event.preventDefault();
      hasInteractedOutsideRef.current = false;
    },
    onInteractOutside: function onInteractOutside(event) {
      var _props$onInteractOuts;
      (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
      if (!event.defaultPrevented && !context.modal) hasInteractedOutsideRef.current = true;
    },
    style: _objectSpread(_objectSpread({}, props.style), {}, {
      '--radix-context-menu-content-transform-origin': 'var(--radix-popper-transform-origin)',
      '--radix-context-menu-content-available-width': 'var(--radix-popper-available-width)',
      '--radix-context-menu-content-available-height': 'var(--radix-popper-available-height)',
      '--radix-context-menu-trigger-width': 'var(--radix-popper-anchor-width)',
      '--radix-context-menu-trigger-height': 'var(--radix-popper-anchor-height)'
    })
  }));
});
/*#__PURE__*/
Object.assign($5de197f6cd80e8e9$export$572205900c9369e, {
  displayName: $5de197f6cd80e8e9$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ContextMenuGroup
 * -----------------------------------------------------------------------------------------------*/
var $5de197f6cd80e8e9$var$GROUP_NAME = 'ContextMenuGroup';
var $5de197f6cd80e8e9$export$9860523b0fcdd664 = /*#__PURE__*/$l8XVT$react.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    groupProps = _objectWithoutProperties(props, _excluded4);
  var menuScope = $5de197f6cd80e8e9$var$useMenuScope(__scopeContextMenu);
  return /*#__PURE__*/$l8XVT$react.createElement($l8XVT$radixuireactmenu.Group, $parcel$interopDefault($l8XVT$babelruntimehelpersextends)({}, menuScope, groupProps, {
    ref: forwardedRef
  }));
});
/*#__PURE__*/
Object.assign($5de197f6cd80e8e9$export$9860523b0fcdd664, {
  displayName: $5de197f6cd80e8e9$var$GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ContextMenuLabel
 * -----------------------------------------------------------------------------------------------*/
var $5de197f6cd80e8e9$var$LABEL_NAME = 'ContextMenuLabel';
var $5de197f6cd80e8e9$export$d4b9d3b609a10742 = /*#__PURE__*/$l8XVT$react.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    labelProps = _objectWithoutProperties(props, _excluded5);
  var menuScope = $5de197f6cd80e8e9$var$useMenuScope(__scopeContextMenu);
  return /*#__PURE__*/$l8XVT$react.createElement($l8XVT$radixuireactmenu.Label, $parcel$interopDefault($l8XVT$babelruntimehelpersextends)({}, menuScope, labelProps, {
    ref: forwardedRef
  }));
});
/*#__PURE__*/
Object.assign($5de197f6cd80e8e9$export$d4b9d3b609a10742, {
  displayName: $5de197f6cd80e8e9$var$LABEL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ContextMenuItem
 * -----------------------------------------------------------------------------------------------*/
var $5de197f6cd80e8e9$var$ITEM_NAME = 'ContextMenuItem';
var $5de197f6cd80e8e9$export$16a26dc176a49100 = /*#__PURE__*/$l8XVT$react.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    itemProps = _objectWithoutProperties(props, _excluded6);
  var menuScope = $5de197f6cd80e8e9$var$useMenuScope(__scopeContextMenu);
  return /*#__PURE__*/$l8XVT$react.createElement($l8XVT$radixuireactmenu.Item, $parcel$interopDefault($l8XVT$babelruntimehelpersextends)({}, menuScope, itemProps, {
    ref: forwardedRef
  }));
});
/*#__PURE__*/
Object.assign($5de197f6cd80e8e9$export$16a26dc176a49100, {
  displayName: $5de197f6cd80e8e9$var$ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ContextMenuCheckboxItem
 * -----------------------------------------------------------------------------------------------*/
var $5de197f6cd80e8e9$var$CHECKBOX_ITEM_NAME = 'ContextMenuCheckboxItem';
var $5de197f6cd80e8e9$export$b6adbe51d5d8b7ec = /*#__PURE__*/$l8XVT$react.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    checkboxItemProps = _objectWithoutProperties(props, _excluded7);
  var menuScope = $5de197f6cd80e8e9$var$useMenuScope(__scopeContextMenu);
  return /*#__PURE__*/$l8XVT$react.createElement($l8XVT$radixuireactmenu.CheckboxItem, $parcel$interopDefault($l8XVT$babelruntimehelpersextends)({}, menuScope, checkboxItemProps, {
    ref: forwardedRef
  }));
});
/*#__PURE__*/
Object.assign($5de197f6cd80e8e9$export$b6adbe51d5d8b7ec, {
  displayName: $5de197f6cd80e8e9$var$CHECKBOX_ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ContextMenuRadioGroup
 * -----------------------------------------------------------------------------------------------*/
var $5de197f6cd80e8e9$var$RADIO_GROUP_NAME = 'ContextMenuRadioGroup';
var $5de197f6cd80e8e9$export$db5c89af5ed9aa07 = /*#__PURE__*/$l8XVT$react.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    radioGroupProps = _objectWithoutProperties(props, _excluded8);
  var menuScope = $5de197f6cd80e8e9$var$useMenuScope(__scopeContextMenu);
  return /*#__PURE__*/$l8XVT$react.createElement($l8XVT$radixuireactmenu.RadioGroup, $parcel$interopDefault($l8XVT$babelruntimehelpersextends)({}, menuScope, radioGroupProps, {
    ref: forwardedRef
  }));
});
/*#__PURE__*/
Object.assign($5de197f6cd80e8e9$export$db5c89af5ed9aa07, {
  displayName: $5de197f6cd80e8e9$var$RADIO_GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ContextMenuRadioItem
 * -----------------------------------------------------------------------------------------------*/
var $5de197f6cd80e8e9$var$RADIO_ITEM_NAME = 'ContextMenuRadioItem';
var $5de197f6cd80e8e9$export$8a727d09a7d9bfc2 = /*#__PURE__*/$l8XVT$react.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    radioItemProps = _objectWithoutProperties(props, _excluded9);
  var menuScope = $5de197f6cd80e8e9$var$useMenuScope(__scopeContextMenu);
  return /*#__PURE__*/$l8XVT$react.createElement($l8XVT$radixuireactmenu.RadioItem, $parcel$interopDefault($l8XVT$babelruntimehelpersextends)({}, menuScope, radioItemProps, {
    ref: forwardedRef
  }));
});
/*#__PURE__*/
Object.assign($5de197f6cd80e8e9$export$8a727d09a7d9bfc2, {
  displayName: $5de197f6cd80e8e9$var$RADIO_ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ContextMenuItemIndicator
 * -----------------------------------------------------------------------------------------------*/
var $5de197f6cd80e8e9$var$INDICATOR_NAME = 'ContextMenuItemIndicator';
var $5de197f6cd80e8e9$export$9ed8194dee42d94b = /*#__PURE__*/$l8XVT$react.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    itemIndicatorProps = _objectWithoutProperties(props, _excluded10);
  var menuScope = $5de197f6cd80e8e9$var$useMenuScope(__scopeContextMenu);
  return /*#__PURE__*/$l8XVT$react.createElement($l8XVT$radixuireactmenu.ItemIndicator, $parcel$interopDefault($l8XVT$babelruntimehelpersextends)({}, menuScope, itemIndicatorProps, {
    ref: forwardedRef
  }));
});
/*#__PURE__*/
Object.assign($5de197f6cd80e8e9$export$9ed8194dee42d94b, {
  displayName: $5de197f6cd80e8e9$var$INDICATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ContextMenuSeparator
 * -----------------------------------------------------------------------------------------------*/
var $5de197f6cd80e8e9$var$SEPARATOR_NAME = 'ContextMenuSeparator';
var $5de197f6cd80e8e9$export$8d6b009fadfe1207 = /*#__PURE__*/$l8XVT$react.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    separatorProps = _objectWithoutProperties(props, _excluded11);
  var menuScope = $5de197f6cd80e8e9$var$useMenuScope(__scopeContextMenu);
  return /*#__PURE__*/$l8XVT$react.createElement($l8XVT$radixuireactmenu.Separator, $parcel$interopDefault($l8XVT$babelruntimehelpersextends)({}, menuScope, separatorProps, {
    ref: forwardedRef
  }));
});
/*#__PURE__*/
Object.assign($5de197f6cd80e8e9$export$8d6b009fadfe1207, {
  displayName: $5de197f6cd80e8e9$var$SEPARATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ContextMenuArrow
 * -----------------------------------------------------------------------------------------------*/
var $5de197f6cd80e8e9$var$ARROW_NAME = 'ContextMenuArrow';
var $5de197f6cd80e8e9$export$f47d0a58228a61e2 = /*#__PURE__*/$l8XVT$react.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    arrowProps = _objectWithoutProperties(props, _excluded12);
  var menuScope = $5de197f6cd80e8e9$var$useMenuScope(__scopeContextMenu);
  return /*#__PURE__*/$l8XVT$react.createElement($l8XVT$radixuireactmenu.Arrow, $parcel$interopDefault($l8XVT$babelruntimehelpersextends)({}, menuScope, arrowProps, {
    ref: forwardedRef
  }));
});
/*#__PURE__*/
Object.assign($5de197f6cd80e8e9$export$f47d0a58228a61e2, {
  displayName: $5de197f6cd80e8e9$var$ARROW_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ContextMenuSub
 * -----------------------------------------------------------------------------------------------*/
var $5de197f6cd80e8e9$var$SUB_NAME = 'ContextMenuSub';
var $5de197f6cd80e8e9$export$5bc21d1c00c4b201 = function $5de197f6cd80e8e9$export$5bc21d1c00c4b201(props) {
  var __scopeContextMenu = props.__scopeContextMenu,
    children = props.children,
    onOpenChange = props.onOpenChange,
    openProp = props.open,
    defaultOpen = props.defaultOpen;
  var menuScope = $5de197f6cd80e8e9$var$useMenuScope(__scopeContextMenu);
  var _$l8XVT$radixuireactu = $l8XVT$radixuireactusecontrollablestate.useControllableState({
      prop: openProp,
      defaultProp: defaultOpen,
      onChange: onOpenChange
    }),
    _$l8XVT$radixuireactu2 = _slicedToArray(_$l8XVT$radixuireactu, 2),
    open = _$l8XVT$radixuireactu2[0],
    setOpen = _$l8XVT$radixuireactu2[1];
  return /*#__PURE__*/$l8XVT$react.createElement($l8XVT$radixuireactmenu.Sub, $parcel$interopDefault($l8XVT$babelruntimehelpersextends)({}, menuScope, {
    open: open,
    onOpenChange: setOpen
  }), children);
};
/*#__PURE__*/
Object.assign($5de197f6cd80e8e9$export$5bc21d1c00c4b201, {
  displayName: $5de197f6cd80e8e9$var$SUB_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ContextMenuSubTrigger
 * -----------------------------------------------------------------------------------------------*/
var $5de197f6cd80e8e9$var$SUB_TRIGGER_NAME = 'ContextMenuSubTrigger';
var $5de197f6cd80e8e9$export$30b2b5c64556d316 = /*#__PURE__*/$l8XVT$react.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    triggerItemProps = _objectWithoutProperties(props, _excluded13);
  var menuScope = $5de197f6cd80e8e9$var$useMenuScope(__scopeContextMenu);
  return /*#__PURE__*/$l8XVT$react.createElement($l8XVT$radixuireactmenu.SubTrigger, $parcel$interopDefault($l8XVT$babelruntimehelpersextends)({}, menuScope, triggerItemProps, {
    ref: forwardedRef
  }));
});
/*#__PURE__*/
Object.assign($5de197f6cd80e8e9$export$30b2b5c64556d316, {
  displayName: $5de197f6cd80e8e9$var$SUB_TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ContextMenuSubContent
 * -----------------------------------------------------------------------------------------------*/
var $5de197f6cd80e8e9$var$SUB_CONTENT_NAME = 'ContextMenuSubContent';
var $5de197f6cd80e8e9$export$2c967063bd2dc512 = /*#__PURE__*/$l8XVT$react.forwardRef(function (props, forwardedRef) {
  var __scopeContextMenu = props.__scopeContextMenu,
    subContentProps = _objectWithoutProperties(props, _excluded14);
  var menuScope = $5de197f6cd80e8e9$var$useMenuScope(__scopeContextMenu);
  return /*#__PURE__*/$l8XVT$react.createElement($l8XVT$radixuireactmenu.SubContent, $parcel$interopDefault($l8XVT$babelruntimehelpersextends)({}, menuScope, subContentProps, {
    ref: forwardedRef,
    style: _objectSpread(_objectSpread({}, props.style), {}, {
      '--radix-context-menu-content-transform-origin': 'var(--radix-popper-transform-origin)',
      '--radix-context-menu-content-available-width': 'var(--radix-popper-available-width)',
      '--radix-context-menu-content-available-height': 'var(--radix-popper-available-height)',
      '--radix-context-menu-trigger-width': 'var(--radix-popper-anchor-width)',
      '--radix-context-menu-trigger-height': 'var(--radix-popper-anchor-height)'
    })
  }));
});
/*#__PURE__*/
Object.assign($5de197f6cd80e8e9$export$2c967063bd2dc512, {
  displayName: $5de197f6cd80e8e9$var$SUB_CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/
function $5de197f6cd80e8e9$var$whenTouchOrPen(handler) {
  return function (event) {
    return event.pointerType !== 'mouse' ? handler(event) : undefined;
  };
}
var $5de197f6cd80e8e9$export$be92b6f5f03c0fe9 = $5de197f6cd80e8e9$export$8dc6765e8be191c7;
var $5de197f6cd80e8e9$export$41fb9f06171c75f4 = $5de197f6cd80e8e9$export$be6fc7b1d5b0beb9;
var $5de197f6cd80e8e9$export$602eac185826482c = $5de197f6cd80e8e9$export$14afd0be83e45060;
var $5de197f6cd80e8e9$export$7c6e2c02157bb7d2 = $5de197f6cd80e8e9$export$572205900c9369e;
var $5de197f6cd80e8e9$export$eb2fcfdbd7ba97d4 = $5de197f6cd80e8e9$export$9860523b0fcdd664;
var $5de197f6cd80e8e9$export$b04be29aa201d4f5 = $5de197f6cd80e8e9$export$d4b9d3b609a10742;
var $5de197f6cd80e8e9$export$6d08773d2e66f8f2 = $5de197f6cd80e8e9$export$16a26dc176a49100;
var $5de197f6cd80e8e9$export$16ce288f89fa631c = $5de197f6cd80e8e9$export$b6adbe51d5d8b7ec;
var $5de197f6cd80e8e9$export$a98f0dcb43a68a25 = $5de197f6cd80e8e9$export$db5c89af5ed9aa07;
var $5de197f6cd80e8e9$export$371ab307eab489c0 = $5de197f6cd80e8e9$export$8a727d09a7d9bfc2;
var $5de197f6cd80e8e9$export$c3468e2714d175fa = $5de197f6cd80e8e9$export$9ed8194dee42d94b;
var $5de197f6cd80e8e9$export$1ff3c3f08ae963c0 = $5de197f6cd80e8e9$export$8d6b009fadfe1207;
var $5de197f6cd80e8e9$export$21b07c8f274aebd5 = $5de197f6cd80e8e9$export$f47d0a58228a61e2;
var $5de197f6cd80e8e9$export$d7a01e11500dfb6f = $5de197f6cd80e8e9$export$5bc21d1c00c4b201;
var $5de197f6cd80e8e9$export$2ea8a7a591ac5eac = $5de197f6cd80e8e9$export$30b2b5c64556d316;
var $5de197f6cd80e8e9$export$6d4de93b380beddf = $5de197f6cd80e8e9$export$2c967063bd2dc512;